import React, { useState } from 'react';
import './BotSwitchModal.css';

const BotSwitchModal = ({ bots, onClose, onBotSelect }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleBotSelect = (botId) => {
    onBotSelect(botId);
  };

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
  };

  const handleBack = () => {
    setSelectedCategory(null);
  };

  return (
    <div className="lcb_bot-switch-modal-overlay" onClick={onClose}>
      <div className="lcb_bot-switch-modal" onClick={(e) => e.stopPropagation()}>
        <div className="lcb_bot-switch-header">
          <h3>{selectedCategory ? selectedCategory : 'Select Bot'}</h3>
          <button className="lcb_close-button" onClick={onClose}>×</button>
        </div>
        
        {selectedCategory ? (
          // Show bots for the selected category
          <div className="lcb_bot-categories">
            <button className="lcb_back-button" onClick={handleBack}>
              ← Back
            </button>
            <div className="lcb_bot-list">
              {bots[selectedCategory].map((bot) => (
                <button
                  key={bot.id}
                  className="lcb_bot-item"
                  onClick={() => handleBotSelect(bot.id)}
                >
                  {bot.name}
                </button>
              ))}
            </div>
          </div>
        ) : (
          // Show categories
          <div className="lcb_bot-categories">
            {Object.keys(bots).map((category) => (
              <div key={category} className="lcb_bot-category">
                <button
                  className="lcb_category-button"
                  onClick={() => handleCategorySelect(category)}
                >
                  {category}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BotSwitchModal; 